import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'tf0015',
    ecrans: ['00-2']
});
